import AbstractModelType from '../AbstractModelType';

class UserContentPrintJob extends AbstractModelType {
  static STATE = {
    complete: 'complete',
    pending: 'pending',
    failed: 'failed',
  };

  #id;
  #pk;

  #displayText;

  #pages;
  #pageNumbers;
  #totalPages;

  #state;
  #canceled;

  #shouldDisplayOnHistory;

  constructor(bookPages, properties = {}) {
    super(...arguments);

    this.#id = properties.id;
    this.#pk = properties.pk;
    this.#displayText = properties.displayText;
    this.#canceled = properties.canceled;

    this.#totalPages = properties.totalPages;

    const parsedPageNumbers = JSON.parse(properties.pageNumbersJsonList);
    this.#pageNumbers = parsedPageNumbers;

    if (bookPages[0]) {
      this.#pages = bookPages.filter((page) =>
        parsedPageNumbers.includes(page.index + 1),
      );
    }

    this.#state = UserContentPrintJob.STATE[properties.state];

    this.#shouldDisplayOnHistory = Boolean(
      this.#state === UserContentPrintJob.STATE.complete && !this.#canceled,
    );
  }

  get id() {
    return this.#id;
  }

  get pk() {
    return this.#pk;
  }

  get displayText() {
    return this.#displayText;
  }

  get canceled() {
    return this.#canceled;
  }

  get totalPages() {
    return this.#totalPages;
  }

  get pageNumbers() {
    return this.#pageNumbers;
  }

  get pages() {
    return this.#pages;
  }

  get state() {
    return this.#state;
  }

  get shouldDisplayOnHistory() {
    return this.#shouldDisplayOnHistory;
  }
}

export default UserContentPrintJob;
